import { faEnvelope, faLock, faPlusCircle, faUser } from "@fortawesome/free-solid-svg-icons";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext } from "react";
import Badge from "../../common/badge/Badge";
import { Column, Row } from "../../common/columns";
import DashboardItem from "../../common/dashboard/DashboardItem";
import { UserContext } from "../../common/user/UserContext";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../common/theme/ThemeContext";
import Icon from "@mdi/react";
import { mdiVote } from "@mdi/js";

function DashboardPage() {
  const user = useContext(UserContext);
  const { t } = useTranslation();
  const theme = useContext(ThemeContext);

  return (
    <div className="container">
      <Row>
        <Column>
          <DashboardItem link="/submitRequest" label={t("requests.submit")} labelSize="3">
            <FontAwesomeIcon
              size="3x"
              className={`has-text-${theme.iconColor} mt-2`}
              icon={faPlusCircle}
            />
          </DashboardItem>
        </Column>
        <Column>
          <DashboardItem link="/requests" label={t("requests.created")} labelSize="3">
            <Badge
              value={user.pendingRequests}
              icon={faEnvelope}
              iconBulmaColor={theme.iconColor}
              size="1"
              iconSize="3"
              className="mt-2"
            />
          </DashboardItem>
        </Column>
        <Column>
          <DashboardItem link="/archive" label={t("requests.archive")} labelSize="3">
            <FontAwesomeIcon
              size="3x"
              className={`has-text-${theme.iconColor} mt-2`}
              icon={faLock}
            />
          </DashboardItem>
        </Column>
      </Row>
      <Row>
        <Column className="is-4">
          <DashboardItem link="/points" label={t("requests.points")} labelSize="3">
            <FontAwesomeIcon
              icon={faCalendar}
              size="3x"
              className={`has-text-${theme.iconColor} mt-2`}
            />
          </DashboardItem>
        </Column>
        <Column className="is-4">
          <DashboardItem link="/profile" label={t("requests.myData")} labelSize="3">
            <FontAwesomeIcon
              icon={faUser}
              size="3x"
              className={`has-text-${theme.iconColor} mt-2`}
            />
          </DashboardItem>
        </Column>
        <Column className="is-4">
          <DashboardItem link="/elections" label={t("requests.voting")} labelSize="3">
            <Icon
              path={mdiVote}
              size={3} // not in use, check scss class "dashboard-vote-icon"
              className={`dashboard-vote-icon has-text-${theme.iconColor} mt-2`}
            />
          </DashboardItem>
        </Column>
      </Row>
    </div>
  );
}

export default DashboardPage;
